import axios from 'axios'
import IRequestParams from '../../types/models'

async function makeRequest(params: IRequestParams) {
  const config = {
    method: params.method,
    maxBodyLength: Infinity,
    url: params.url,
    headers: {
      'Content-Type': 'application/json',
      ...params.headers, // Allows for additional headers to be added
    },
    data: params.data,
    params: params.params, // Add support for query parameters
  }

  const response = await axios.request(config)
  return response
}

export default makeRequest
